import React from "react";
import { Navbar } from "../header";
import { Footer } from "../footer";
import "./PortfolioPage.css";

export const BirthdayPortfolio = () => {
  const galleryImages = [
    {
      id: 1,
      src: "/resources/images/birthday1.jpeg",
      category: "Kids",
      title: "Magical Childhood Moments"
    },
    {
      id: 2,
      src: "/resources/images/birthday2.jpeg",
      category: "Kids",
      title: "Cake Smash Delight"
    },
    {
      id: 3,
      src: "/resources/images/birthday3.jpeg",
      category: "Kids",
      title: "Birthday Princess"
    },
    {
      id: 4,
      src: "/resources/images/birthday4.jpeg",
      category: "Kids",
      title: "Superhero Birthday Bash"
    },
    {
      id: 5,
      src: "/resources/images/birthday5.jpeg",
      category: "Kids",
      title: "Blowing Candles"
    },
    {
      id: 6,
      src: "/resources/images/birthday6.jpeg",
      category: "Kids",
      title: "Party Games Fun"
    },
    {
      id: 7,
      src: "/resources/images/birthday7.jpeg",
      category: "Kids",
      title: "Gift Opening Joy"
    },
    {
      id: 8,
      src: "/resources/images/birthday8.jpeg",
      category: "Kids",
      title: "Balloon Paradise"
    },
    {
      id: 9,
      src: "/resources/images/birthday9.jpeg",
      category: "Kids",
      title: "First Birthday Special"
    },
    {
      id: 10,
      src: "/resources/images/birthday10.jpeg",
      category: "Kids",
      title: "Party Friends"
    },
    {
      id: 11,
      src: "/resources/images/birthday11.jpeg",
      category: "Kids",
      title: "Themed Party Magic"
    },
    {
      id: 12,
      src: "/resources/images/birthday12.jpeg",
      category: "Kids",
      title: "Sweet Treats"
    },
    {
      id: 13,
      src: "/resources/images/birthday13.jpeg",
      category: "Kids",
      title: "Candid Moments"
    },
    {
      id: 14,
      src: "/resources/images/birthday14.jpeg",
      category: "Kids",
      title: "Party Decorations"
    },
    {
      id: 15,
      src: "/resources/images/birthday15.jpeg",
      category: "Kids",
      title: "Birthday Dance"
    },
    {
      id: 16,
      src: "/resources/images/birthday16.jpeg",
      category: "Kids",
      title: "Outdoor Celebration"
    },
    {
      id: 17,
      src: "/resources/images/birthday17.jpeg",
      category: "Kids",
      title: "Birthday Wishes"
    },
    {
      id: 18,
      src: "/resources/images/birthday18.jpeg",
      category: "Kids",
      title: "Party Activities"
    },
    {
      id: 19,
      src: "/resources/images/birthday19.jpeg",
      category: "Kids",
      title: "Family Moments"
    },
    {
      id: 20,
      src: "/resources/images/birthday20.jpeg",
      category: "Kids",
      title: "Birthday Surprises"
    },
    {
      id: 21,
      src: "/resources/images/birthday21.jpeg",
      category: "Kids",
      title: "Happy Memories"
    }
  ];

  return (
    <div className="portfolio-detail-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="portfolio-detail-hero">
        <h1 className="detail-hero-title">Birthday Photography</h1>
        <div className="title-line"></div>
        <p className="detail-hero-subtitle">Capturing Joy and Celebration at Every Age</p>
      </section>

      {/* Introduction */}
      <section className="portfolio-intro">
        <div className="intro-content">
          <h2>Birthday Celebrations</h2>
          <p>Every birthday is a milestone worth celebrating. At Stories by Kalakaar, we specialize in capturing the pure joy, excitement, and precious moments that make birthday celebrations unforgettable. From children's parties to milestone adult celebrations, we preserve these special memories in stunning detail.</p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="portfolio-gallery">
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div key={image.id} className="gallery-item">
              <div className="image-wrapper">
                <img src={image.src} alt={image.title} />
                <div className="image-overlay">
                  <div className="image-info">
                    <span className="image-category">{image.category}</span>
                    <h3 className="image-title">{image.title}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="portfolio-services">
        <div className="services-content">
          <h2>Our Birthday Services</h2>
          <div className="services-grid">
            <div className="service-item">
              <h3>Kids Parties</h3>
              <p>Capturing magical moments of childhood joy</p>
            </div>
            <div className="service-item">
              <h3>Milestone Celebrations</h3>
              <p>Special coverage for significant birthdays</p>
            </div>
            <div className="service-item">
              <h3>Party Highlights</h3>
              <p>Documenting all the fun and festivities</p>
            </div>
            <div className="service-item">
              <h3>Photo Albums</h3>
              <p>Beautiful keepsakes of the celebration</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="portfolio-cta">
        <div className="cta-content">
          <h2>Ready to Capture Your Celebration?</h2>
          <p>Let's make your birthday memories last forever</p>
          <a href="/contactUs" className="cta-button">Get in Touch</a>
        </div>
      </section>

      <Footer />
    </div>
  );
}; 